<template>
    <v-dialog
        v-if="$rc.inIndustry('wine')"
        v-model="show_modal"
        max-width="800"
        persistent
        scrollable
    >
        <v-card>
            <v-card-title class="error white--text">
                <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
                Urgent Emerging Carrier Issue
            </v-card-title>

            <v-card-text class="pt-4">
                <p>
                    We recommend you temporarily refrain from sending bulk messages that promote wine sales. We're seeing unusual carrier blocking and will share updates as soon as we have more clarity.
                </p>
                
                <winery-carrier-alert-content show="latest-update" />

                <div class="mb-3">
                    <a
                        href="#"
                        @click.prevent="show_details = !show_details"
                    >
                        {{ show_details ? 'Read less' : 'Read more' }}
                        <v-icon color="primary" small>{{ show_details ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </a>
                </div>

                <v-expand-transition>
                    <div v-show="show_details">
                        <winery-carrier-alert-content show="expanded-content" />
                    </div>
                </v-expand-transition>
            </v-card-text>

            <v-card-actions class="shaded-light">
                <v-spacer />
                <v-btn
                    color="primary"
                    @click="onDismiss"
                >
                    I Understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';

const STORAGE_KEY = 'winery_carrier_alert_dismissed';

export default {
    name: 'TempDisableWineriesFromSchedulingModal',

    components: {
        WineryCarrierAlertContent,
    },

    data() {
        return {
            show_details: false,
            show_modal: false,
        };
    },

    mounted() {
        this.checkShouldShow();
    },

    methods: {
        checkShouldShow() {
            const dismissed_date = localStorage.getItem(STORAGE_KEY);
            const today = new Date().toISOString().split('T')[0];

            if (dismissed_date !== today) {
                this.show_modal = true;
            }
        },

        onDismiss() {
            const today = new Date().toISOString().split('T')[0];
            localStorage.setItem(STORAGE_KEY, today);
            this.show_modal = false;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>
